import "yakuhanjp";
import "yakuhanjp/dist/css/yakuhanmp.css";
import Top from "./components/index/Top";
import About from "./components/index/About";
import Menu from "./components/Menu";
import Header from "./components/Header";
import styled from "styled-components";
import { Routes, Route, Navigate } from "react-router-dom";
import PlacelistDetail from "./components/placelist/PlacelistDetail";

import ScrollToTop from "./ScrollToTop";
import Copyright from "./components/Copyright";
import { media } from "./utils/media";
import PlacelistDetail1 from "components/placelist/PlacelistDetail1";
import PlacelistDetail2 from "components/placelist/PlacelistDetail2";
import PlacelistDetail3 from "components/placelist/PlacelistDetail3";

const App = () => {
  return (
    <Main>
      <Header />
      <Menu />
      {/* <Top />
      <About /> */}
      {/* <PlacelistDetail1 /> */}
      {/* <PlacelistDetail2 /> */}
      <PlacelistDetail3 />
      {/* <ScrollToTop>
        <Routes>
          <Route
            path="ja/jp/domtour/theme/workation/music"
            element={
              <>
                <Top />
                <About />
              </>
            }
          />
          <Route
            path="ja/jp/domtour/theme/workation/music/placelist/bose"
            element={<PlacelistDetail id="bose" />}
          />
          <Route
            path="ja/jp/domtour/theme/workation/music/placelist/natsumetomoyuki"
            element={<PlacelistDetail id="natsumetomoyuki" />}
          />
          <Route
            path="ja/jp/domtour/theme/workation/music/placelist/tsuji-imai"
            element={<PlacelistDetail id="tsuji-imai" />}
          />
        </Routes>
      </ScrollToTop> */}
      <Copyright />
    </Main>
  );
};

const Main = styled.div`
  ${media.sp`
    padding-top: 75px;
  `}
  ${media.pc`
    padding-top: 92px;
  `}
`;

export default App;
